import P from 'components/Font/P'
import React from 'react'

function UpcomingDrops() {
  return (
    <div> <P style={{ pl: 2 }} fontWeight={600} fontSize={35} fontFamily="Redressed">UpcomingDrops</P></div>
  )
}

export default UpcomingDrops